module.exports = __webpack_public_path__ + "static/media/board-mercosul.bbbdc20f.png";